import React, { useState, useEffect } from "react";
import {
  Row,
  Container,
  InputGroup,
  Button,
  ButtonToolbar,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import "../../../../../node_modules/react-bootstrap-typeahead/css/Typeahead.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { getCandidateList, getReport } from "../../../Slices/orgAdminSlice";
import ReportsTable from "../../../components/ReportsTable/ReportsTable";
import TimeLinePicker from "../../../containers/TimeLinePicker/TimeLinePicker";
import CandidateSearchBar from "../../../components/CandidateSearchBar/CandidateSearchBar";

const Reports = () => {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const dispatch = useDispatch();
  const { candidates } = useSelector((state) => state.orgAdminSlice);
  const { fromDate, toDate, sessionUser:{timezone}, sessionUser } = useSelector(
    (state) => state.sessionSlice
  );

  const clientId = sessionUser;

  useEffect(() => {
    dispatch(getCandidateList());
  }, [dispatch]);

  useEffect(() => {
    if (fromDate && toDate) {
      dispatch(
        getReport({
          candidates: selectedCandidates,
          fromDate,
          toDate,
          timezone,
          clientId,
        })
      );
    }
  }, [selectedCandidates, timezone, fromDate, toDate, dispatch]);

  return (
    <>
      <Container>
        <Row className={"mt-4 shadow-sm p-3 bg-body rounded"}>
          <TimeLinePicker />
        </Row>
        <Row className="mt-4 shadow-sm p-3 mb-5 bg-body rounded">
          <InputGroup className="mb-2">
            <InputGroup.Text id="basic-addon1">candidates</InputGroup.Text>
            <CandidateSearchBar
              multiple={true}
              selectedCandidates={selectedCandidates}
              defaultSelected={selectedCandidates}
              handleSelection={setSelectedCandidates}
            />
          </InputGroup>
          <ButtonToolbar>
            <Button
              variant={"outline-secondary"}
              outline
              onClick={() => setSelectedCandidates([])}
              size="sm"
              className={"g-2"}
            >
              Clear
            </Button>
            <Button
              variant={"outline-secondary"}
              onClick={() => setSelectedCandidates(candidates)}
              size="sm"
              className={"g-2"}
            >
              select all
            </Button>
          </ButtonToolbar>
        </Row>
        <Row>
          <ReportsTable />
        </Row>
      </Container>
    </>
  );
};

export default Reports;
